export const ja = {
    title: '承認ポップアップ',
    content_sign: '[続行] をクリックして、署名またはトランザクションを完了します',
    content_login: '[続行] をクリックして、ウォレットの作成または接続を完了します',
};
